// BUROMAT.JS /////////////////////////////////////////////////////


// LAZYLOAD /////////////////////////////////////////////////////
var myLazyLoad = new LazyLoad({
  elements_selector: ".wp-post-image,.lazy",
  load_delay: 2000
});




// NAVBAR EFFECT ON SCROLL /////////////////////////////////////////////////
var scrollpos = window.scrollY
var header = document.getElementById("nav")

var header_height = "200"
window.addEventListener('scroll', function () {
  scrollpos = window.scrollY;
  if (scrollpos >= header_height) {
    header.classList.add("navbar-scrolled")
  } else {
    header.classList.remove("navbar-scrolled")
  }
});





// GET HOME URL ////////////////////////////////////////////////
function getHomeUrl() {
  var href = window.location.href;
  var index = href.indexOf('/wp-admin');
  var homeUrl = href.substring(0, index);
  return homeUrl;
}




// IMAGES EQUIPE
var bgs = jQuery('.post-equipe');
bgs.each(function () {
  ScrollOut({
    targets: jQuery(this).find('.hentry'),
    once: false,
  });
});


// SCROLLOUT EFFECT
var bgs = jQuery('.scrollOut');
bgs.each(function () {
  ScrollOut({
    targets: jQuery(this),
  });
});



// GLIDE.JS /////////////////////////////////////////////////////
new Glide('.glide', {
  perView: 5,
  type: 'carousel',
  autoplay: 2000,
  breakpoints: {
    600: {
      perView: 1
    },
    1200: {
      perView: 3
    }
  }
}).mount();







// LIGHTBOX ////////////////////////////////////////////////////
baguetteBox.run('.lightbox', {
  animation: 'slideIn'
});




jQuery('.collapse-masonrynav').click(function(){
  jQuery(this).next('.masonry-nav').slideToggle();
});




// MASONRY ////////////////////////////////////////////////////
jQuery(window).load(function ($) {

  var $container = jQuery('.masonry');


  function realisations_isotope() {
    $container.imagesLoaded(function () {
      $container.isotope({
        itemSelector: '.masonry-item',
        gutter: 0,
        layoutMode: 'masonry',
      });
    });
  };
  realisations_isotope();

  function quisommesnous_isotope() {
    jQuery('.masonry--alt').imagesLoaded(function () {
      jQuery('.masonry--alt').isotope({
        itemSelector: '.masonry-qsm',
        gutter: 0,
        layoutMode: 'masonry',
      });
    });
  };
  quisommesnous_isotope();





  /* Filtre */
  jQuery('.masonry-nav li a').click(function () {
    var selector = jQuery(this).attr('data-filter');
    jQuery('#masonry').isotope({ filter: selector });
    jQuery(this).parents('ul').find('li a').removeClass('active');
    jQuery(this).addClass('active');
    return false;
  });

  jQuery('.masonry-nav-collapse').click(function () {
    jQuery('.masonry-nav').toggleClass('visible');
    jQuery('.masonry-nav-collapse').find('svg').toggleClass('visible');
  });


  jQuery(window).resize(function () {
    realisations_isotope();
  });


  /* Orientation */
  window.addEventListener("orientationchange", function () {
    realisations_isotope();
  });
});

